<template>
    <main-table-layout>
            <div slot="mainContent">
                Here follows the help section...
            </div>
    </main-table-layout>
</template>

<script>
    import MainTableLayout from "../layouts/MainTableLayout";
    export default {
        name: "Help",
        components: {
            MainTableLayout
        },
        data() {
            return {
                forceReRenderKey: 0,
            };
        },
        methods: {

        }
    }
</script>